import React from 'react';
import { getSysFieldid } from '@platform/api';

//模板配置的操作列 (和代码写的操作列不同)
function useOprCol(Table) {
    return class useOprColTable extends React.Component{
        render(){
            let {columns = [], locale, store, pageScope, id } = this.props;
            let {buttons = []} = store.getConfig()
            buttons = buttons.filter((b)=> b.key && b.title)
            let buttonKey = buttons.map(i=>i.key)
            if(buttons.length){
                columns = [...columns,{
                    title: <div 
                        className='table-next-header-title'
                        fieldid={getSysFieldid('opr')}
                    >
                        {locale['table_opr'] /*'操作'*/}
                    </div>,
                    label:locale['table_opr'] ,
                    key: 'opr',
                    itemtype:'customer',
                    resizable: true,
                    width: 178,
                    visible:true,
                    isleaf: true,
                    depth: 0,
                    fixed: 'right',
                    render: (row, index) => {
                        return <div className='table-cell'>
                            {
                                pageScope.button.createOprationButton(
                                    buttonKey,
                                    {
                                        area: buttons[0].area || `${id}_inner`,
                                        buttonLimit: 3,
                                        onButtonClick: () => {},
                                    }
                              ) 
                            }
                        </div>;
                    },
                }];
            }
            return (
                <Table {...this.props} columns={columns}/>
            );
        }
    };
}

useOprCol.displayName = 'useOprCol';
useOprCol.dependence = [];
useOprCol.propsGenerator = function(props){
  
    return {
        ...props,
    };
};

export default useOprCol;